// extracted by mini-css-extract-plugin
export default {"_":"loading____VsM0R","_2":"loading__2__+9r-K","fan":"loading_fan__sqgqY","circle-to-square":"loading_circle-to-square__u7r-X"};